import { stateKey } from './actions'

export const selectCheckedTableRows = state => state[stateKey].selectedTableRows;
export const selectCheckboxValue = state => state[stateKey].isChecked;
